export default "__VITE_ASSET__B8U6ytwm__"